import { useRunChecklistStore } from '@/stores/run/run-checklist.store';
import { shallow } from 'zustand/shallow';
import { RunChecklistTree } from '../../run-by-id.component';
import RunTaskPhotoThumb from './run-task-photo-thumb.component';

/**
 * Next to each task when a run is opened from Analytics: the photo that decided this task.
 * Photos are taken from the one camera at the top of the run (RunPhotoCheckBar), not per task.
 */
export default function RunTaskPhotoCheckButton({
  node
}: {
  node: RunChecklistTree;
}) {
  const [isSingleResponse] = useRunChecklistStore(
    s => [s.isSingleResponse],
    shallow
  );
  if (!node?.checklist?.task_id || !isSingleResponse) return <></>;
  return <RunTaskPhotoThumb taskId={node.checklist.task_id} />;
}
